import React, {useState } from "react";
import { FormGroup, Form, Container } from "react-bootstrap";
import { Breadcrumb, MainHeader, MainFooter } from "../../components";
import { Input } from 'antd';
import { Link } from "react-router-dom";

function AffiliateResetpassword() {
    const breadcrumb = [
        {
            path: '/Home',
            name: 'Home',
        },
        {
            path: '#',
            name: 'Reset Password',
        },
    ];

    

    const Eye=()=>{
        if(password==="password"){
            setpassword("text");
            seteye(false);
        }
        else{
            setpassword("password");
            seteye(true);
        }
    }
    const Eye2=()=>{
        if(password2==="password"){
            setpassword2("text");
            seteye2(false);
        }
        else{
            setpassword2("password");
            seteye2(true);
        }
    }
    const[eye,seteye]=useState(true);
    const[eye2,seteye2]=useState(true);
    const[password,setpassword]=useState("password");
    const[password2,setpassword2]=useState("password");

    return (
        <>
            <MainHeader />
            <main className="becomePage becomePage_affiliate">
                <Container>
                    <Breadcrumb title="Reset Password" breadcrumb={breadcrumb} />
                    <div className="becomePage_inner">
                        <div className="becomePage_signup text-center">
                        <div className="becomePage_head mb-0">
                            <h2 className="mb-1 font-sm">Reset Password</h2>
                            </div>
                            <p>Hey, Nikola Laringo</p>
                        </div>
                        <div className="becomePage_auth mx-auto">
                            <Form>
                                <FormGroup className="form-group" >        
                                    <label className="ant-label">Create New Password</label>    
                                    <div className="position-relative">                                                      
                                        <Input type={password}  size="large" placeholder="First Name" />
                                        <Link className=" input-icon">         
                                            <i onClick={Eye} className={`fa ${eye ? "gg-eye-off" : "gg-eye-on" }`}></i>
                                        </Link>
                                     </div>
                                </FormGroup>
                                <FormGroup className="form-group position-relative" >
                                    <label className="ant-label">Confirm New Password</label>
                                    <div className="position-relative">       
                                        <Input type={password2}  size="large" placeholder="First Name" />
                                        <Link className=" input-icon">         
                                            <i onClick={Eye2} className={`fa ${eye2 ? "gg-eye-off" : "gg-eye-on" }`}></i>
                                        </Link>
                                    </div>
                                </FormGroup>
                                <div className="text-center becomePage_affiliate_btn mb-0">
                                    <Link to="/affiliate-login" className="ms-auto w-100 btn-lg btn btn-primary">Submit</Link>
                                </div>
                            </Form>
                        </div>
                    </div>
                </Container>
            </main>
            <MainFooter />
        </>
    );
}

export default AffiliateResetpassword;